import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import { BasicInfoSummary } from '../SubComponents/BasicInfoSummary'
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import SvgIcon from '@material-ui/core/SvgIcon';
import ExpandMoreIcon from '../../../../icons/expand-more.svg';
import CurrencyFormat from '../../../Helpers/Formatters/CurrencyFormat'
import './Summary.scss'


function SummaryDetails(props) {
    const data = [
        {
            title: 'Coverage Amount',
            value: props.coverageAmount && <NumberFormat value={props.coverageAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} />
        },
        {
            title: 'Carrier',
            value: props.carrier
        },
        {
            title: 'Term',
            value: props.termLength ? `${props.termLength} Year Term` : null
        },
        {
            title: 'Premium',
            value: props.premium && <span><CurrencyFormat number={props.premium} />/mo</span>
        }
    ];

    return (
        <div className="details">
            <h3 className="text-center">{props.title}</h3>
            <p className="text-center">{props.product}</p>
            <div className="details-section">
                {data.map((s, index) => s.value &&
                    <div key={index}>
                        <h4>{s.title}</h4>
                        <p className="product-detail-value">{s.value}</p>
                    </div>
                )}
            </div>

            {props.carrierLogoUrl &&
                <div className="carrier-image mb-4">
                    <img className="carrier-logo" src={props.carrierLogoUrl} alt={`${props.carrierName} Logo`} />
                </div>
            }

            <BasicInfoSummary
                gender={props.basicInfo.gender}
                state={props.basicInfo.state}
                birthdate={props.basicInfo.birthdate}
                tobacco={props.basicInfo.tobacco}
                height={props.basicInfo.height}
                weight={props.basicInfo.weight}
            />
        </div>
    )
}

export default function Summary(props) {
    const title = props.title || 'Quote Summary'
    return (
        <div className="application-summary">
          <Accordion className="p-0 m-0 small-screen" >
              <AccordionSummary
                    expandIcon={<SvgIcon component={ExpandMoreIcon} />}
                    aria-controls="summary-content"
                    id="summary-header"
                    className="p-0 m-0"
                >
                    <h3 className="m-0 text-center">{title}</h3>
              </AccordionSummary>
          <AccordionDetails className="flex-column p-0 pb-4">
                    <SummaryDetails {...props} />
          </AccordionDetails>
        </Accordion>
            <div className="large-screen">
                <SummaryDetails {...props} title={title} />
            </div>

        </div>
    )
}

Summary.propTypes = {
    title: PropTypes.string,
    product: PropTypes.string.isRequired,
    coverageAmount: PropTypes.number,
    carrierName: PropTypes.string,
    termLength: PropTypes.number,
    premium: PropTypes.number,
    carrierLogoUrl: PropTypes.string,
    basicInfo: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Quoters/Common/Appointment/Summary.js